
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboards from 'vue-clipboards';
import { myPlugin } from '@/utils'
import { checkParam, checkSubmit, checkInput } from '@/verify/config'
Vue.config.productionTip = false


Vue.use(Vant);
Vue.use(VueClipboards);

Vue.directive('checkParam', checkParam)
Vue.directive('checkSubmit', checkSubmit)
Vue.directive('checkInput', checkInput)

/* eslint-disable no-new */
if (!localStorage.getItem('I')&&location.href.indexOf('alipayTemplates')<0) {
  if (/^muc/.test(window.location.host) && window.location.href.indexOf('token') < 0) {
    window.location.href = '/login';
  } else {
    new Vue({
      el: '#app',
      store,
      router,
      render: h => h(App)
    })
  }
} else {
  new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
  })
}


// WEBPACK FOOTER //
// ./src/main.js